import { api } from './client';

export const analyticsAPI = {
  getLoadSummary: (weeksOffset = 0) => api.get('/analytics/load-summary/', { params: { weeks_offset: weeksOffset } }),
  acceptVolumeProgression: (payload) => api.post('/athlete/accept-volume-progression/', payload),
};